<template>
	<v-card>
		<s-crud :config="config" title="Presupuesto" :filter="filter" search-input add edit remove
			@save="saveBudget($event)" ref="scrudBudget" @rowSelected="rowSelected($event)" :rowDefault="false"
			@clearForm="onClearForm()" @addEvent="onClearForm()" height="76dvh">

			<template v-slot:options>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn icon v-on="on" small color="success" @click="dialogReport = true">
							<v-icon small>mdi-file-excel</v-icon>
						</v-btn>
					</template>
					<span>Exportar Reporte Excel</span>
				</v-tooltip>
			</template>

			<template v-slot="props">
				<v-container fluid class="premium-budget-workspace">
					<v-row class="workspace-grid" dense>
						<v-col cols="12" md="6" class="workspace-main">
							<div class="workspace-card main-info-card mb-2">
								<div class="card-gradient-top blue-gradient"></div>
								<div class="card-inner-header">
									<v-icon color="#2563eb" class="mr-2">mdi-folder-text-outline</v-icon>
									<div class="title-group">
										<h3>Especificación del Proyecto</h3>
										<!-- <p>Identificación formal y descripción general del proyecto</p> -->
									</div>
								</div>
								<div class="card-inner-body">
									<v-row dense>
										<v-col cols="12" sm="3">
											<s-text label="Código Proyecto" v-model="props.item.PrjCode"
												@keyupEnter="onProjectSearch($event, props.item)" />
										</v-col>
										<v-col cols="12" sm="9">
											<div class="d-flex align-end" style="gap:6px;">
												<div style="flex:1; min-width:0;">
													<s-select label="Proyecto (Seleccione)*" :items="itemsProjects"
														item-text="GenDescription" item-value="GenHelper" autocomplete
														clearable :value="props.item.PrjCode"
														@input="onProjectSelected($event, props.item)" />
												</div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-btn depressed small color="primary" dark v-on="on"
															@click="dialogProject = true" class="text-none rounded-lg"
															style="font-size:12px; letter-spacing:0.01em; white-space:nowrap;">
															<v-icon small class="">mdi-plus</v-icon>
															<!-- Nuevo -->
														</v-btn>
													</template>
													<span>Nuevo / Editar Proyecto SAP</span>
												</v-tooltip>
											</div>
										</v-col>
										<v-col cols="12">
											<s-textarea label="Detalle de Inversión" v-model="props.item.PrjDescription"
												:rows="1" auto-grow />
										</v-col>
									</v-row>
								</div>
							</div>

							<!-- CARD 2: CONVERTIDOR DE MONEDA (THE CURRENCY BRIDGE) -->
							<div class="workspace-card currency-bridge-card">
								<div class="card-gradient-top green-gradient"></div>
								<div class="card-inner-header d-flex justify-space-between align-center">
									<div class="d-flex align-center">
										<v-icon color="#059669" class="mr-2">mdi-calculator-variant-outline</v-icon>
										<div class="title-group">
											<h3>Presupuesto y Tipo de Cambio</h3>
											<!-- <p>Ingreso de saldos y cálculo de conversión bidireccional</p> -->
										</div>
									</div>
									<div class="header-tc-badge">
										<span class="badge-label">T/C SAP</span>
										<span class="badge-value">
											{{ (props.item.BgtRatePrice || tipoCambio) ?
												(props.item.BgtRatePrice || tipoCambio) : '—' }}
										</span>
									</div>
								</div>
								<div class="card-inner-body">
									<div class="currency-bridge-layout-2col" style="align-items: start;">
										<!-- Columna 1: Selección de Moneda -->
										<div>
											<span
												class="caption font-weight-bold grey--text text--darken-1 d-block mb-1">
												Moneda Base
											</span>
											<div class="ios-segmented-control" style="margin-bottom: 0;">
												<div class="ios-slider"
													:class="{ 'slide-right': props.item.BgtCurrencyType == 2 }">
												</div>
												<div class="ios-option option-currency"
													:class="{ 'active': props.item.BgtCurrencyType == 1 || !props.item.BgtCurrencyType }"
													@click="$set(props.item, 'BgtCurrencyType', 1)">
													SOLES
												</div>
												<div class="ios-option option-currency"
													:class="{ 'active': props.item.BgtCurrencyType == 2 }"
													@click="$set(props.item, 'BgtCurrencyType', 2)">
													DOLARES
												</div>
											</div>

											<!-- T/C input (visible only if Dollars) -->
											<div v-if="props.item.BgtCurrencyType == 2" class="mt-2">
												<s-text type="decimal" label="T/C SAP *"
													:value="props.item.BgtRatePrice || tipoCambio"
													@input="onRatePriceInput($event, props.item)"
													:disabled="props.item.BgtID > 0" />
											</div>
										</div>

										<!-- Columna 2: Saldo Inicial -->
										<div class="currency-panel"
											:class="props.item.BgtCurrencyType == 2 ? 'usd-panel' : 'pen-panel'"
											style="padding: 6px 8px;">
											<div class="panel-header" style="margin-bottom: 4px;">
												<span class="flag-badge">
													{{ props.item.BgtCurrencyType == 2 ? 'USD' : 'PEN' }}
												</span>
												<span class="currency-name">
													{{ props.item.BgtCurrencyType == 2 ? 'Dólares ($)' : 'Soles (S/.)'
													}}
												</span>
											</div>
											<s-text v-if="props.item.BgtCurrencyType == 2" type="decimal"
												label="Saldo Inicial*" :value="props.item.BgtInitialBalanceUSD"
												@input="onInitialBalanceUSDInput($event, props.item)"
												class="premium-field" :disabled="props.item.BgtID > 0" />
											<s-text v-else type="decimal" label="Saldo Inicial*"
												:value="props.item.BgtInitialBalance"
												@input="onInitialBalanceSolesInput($event, props.item)"
												class="premium-field" :disabled="props.item.BgtID > 0" />

											<!-- Conversión a la otra moneda -->
											<div class="conversion-preview" style="margin-top: 4px; padding: 4px 8px;">
												<v-icon size="12"
													:color="props.item.BgtCurrencyType == 2 ? '#10b981' : '#3b82f6'"
													class="mr-1">
													mdi-swap-horizontal
												</v-icon>
												<span
													class="conversion-label grey--text text--darken-2 mr-1">Conversión:</span>
												<span class="conversion-value font-weight-black">
													{{ props.item.BgtCurrencyType == 2 ?
														formatMoneyPEN(props.item.BgtInitialBalance) :
														formatMoneyUSD(props.item.BgtInitialBalanceUSD) }}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-col>

						<v-col cols="12" md="6" class="workspace-sidebar">
							<div class="workspace-card sidebar-card h-100">
								<div class="card-gradient-top purple-gradient"></div>
								<div class="card-inner-header">
									<v-icon color="#7c3aed" class="mr-2">mdi-shape-outline</v-icon>
									<div class="title-group">
										<h3>Gestión & Clasificación Contable</h3>
										<!-- <p>Responsables, dimensiones y centro de costos del presupuesto</p> -->
									</div>
								</div>
								<div class="card-inner-body">
									<v-row dense>
										<!-- Fila 1: DNI Gerente y DNI Usuario -->
										<v-col cols="12" sm="6">
											<div class="sidebar-input-group">
												<s-toolbar-person noCamera noEdit label="Gerente Responsable (DNI)"
													:isManager="1" v-model="props.item.PrjResponsibleManagerDocument"
													@returnPerson="onPersonSelected($event, props.item, 'PrjResponsibleManager')"
													titleDialog="Listado de Gerentes Responsables" />
												<div class="name-display-inline mt-1"
													v-if="props.item.PrjResponsibleManagerName">
													<v-icon x-small color="#64748b" class="mr-1">mdi-account</v-icon>
													<span>{{ props.item.PrjResponsibleManagerName }}</span>
												</div>
											</div>
										</v-col>
										<v-col cols="12" sm="6">
											<div class="sidebar-input-group">
												<s-toolbar-person noCamera noEdit label="Usuario Responsable (DNI)"
													v-model="props.item.PrjResponsibleUserDocument"
													@returnPerson="onPersonSelected($event, props.item, 'PrjResponsibleUser')"
													titleDialog="Listado de Usuarios Responsables" />
												<div class="name-display-inline mt-1"
													v-if="props.item.PrjResponsibleUserName">
													<v-icon x-small color="#64748b" class="mr-1">mdi-account</v-icon>
													<span>{{ props.item.PrjResponsibleUserName }}</span>
												</div>
											</div>
										</v-col>

										<v-col cols="12" sm="6">
											<s-select-area label="Gte. Presupuesto (Área)*"
												v-model="props.item.BgtManager" full noDefault />
										</v-col>
										<v-col cols="12" sm="6">
											<s-select-area label="Área*" v-model="props.item.AreID" full noDefault />
										</v-col>

										<v-col cols="12" sm="8">
											<s-select-area label="División*" v-model="props.item.BgtDivision" full
												noDefault />
										</v-col>
										<v-col cols="12" sm="4">
											<s-text type="number" label="Año*" v-model="props.item.BgtYear" />
										</v-col>

										<v-col cols="12" sm="4">
											<s-select-definition :def="1678" label="Tipo de Proyecto*"
												v-model="props.item.BgtType" />
										</v-col>
										<v-col cols="12" sm="4">
											<s-select-definition :def="1679" label="Tipo de Inversión*"
												v-model="props.item.BgtInvestment" />
										</v-col>
										<v-col cols="12" sm="4">
											<s-select-definition :def="1680" label="Clasificación*"
												v-model="props.item.BgtClassification" />
										</v-col>

										<v-col cols="12" sm="6">
											<s-select-area centercost label="Centro de Costo" v-model="props.item.CceID"
												:onlyAccountCapex="1" :show-all="true" :value="selected?.CceID"
												:text="selected?.CceName"
												@input="onCenterCostSelected($event, props.item)" />
										</v-col>

										<v-col cols="12" sm="6">
											<s-select-business-line v-model="props.item.BslID"
												:cceID="props.item && props.item.CceID ? props.item.CceID : undefined"
												label="Línea de Negocio" />
										</v-col>
									</v-row>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</template>

			<template v-slot:Detail="{ row }">
				<div class="d-flex align-center">
					<v-btn icon small color="info" @click="openDetail(row.BgtID)" title="Ver Historial de Movimientos">
						<v-icon small>mdi-format-list-bulleted</v-icon>
					</v-btn>
					<v-btn icon small color="amber darken-3" @click="openAlteration(row)"
						title="Ajustes y Alteraciones de Presupuesto" class="ml-1">
						<v-icon small>mdi-scale-balance</v-icon>
					</v-btn>
				</div>
			</template>

			<template v-slot:PrjCode="{ row }">
				{{ row.PrjCode }}
				<v-chip v-if="row.PrjCodeSAP" x-small color="success"
					class="pa-2 px-1 rounded font-weight-bold caption ml-1">
					SAP
				</v-chip>
			</template>

			<template v-slot:BgtInitialBalance="{ row }">
				<div class="font-weight-medium text-center">{{ formatMoneyPEN(row.BgtInitialBalance) }}</div>
				<div class="text-center">
					<v-chip x-small dark color="primary" class="pa-2 rounded font-weight-bold">
						{{ formatMoneyUSD(row.BgtInitialBalanceUSD) }}
					</v-chip>
				</div>
			</template>

			<template v-slot:BgtAccountingBalance="{ row }">
				<div class="font-weight-medium text-center">{{ formatMoneyPEN(row.BgtAccountingBalance) }}</div>
				<div class="text-center">
					<v-chip x-small dark color="primary" class="pa-2 rounded font-weight-bold">
						{{ formatMoneyUSD(row.BgtAccountingBalanceUSD) }}
					</v-chip>
				</div>
			</template>

			<template v-slot:BgtReservedBalance="{ row }">
				<div class="font-weight-medium text-center">{{ formatMoneyPEN(row.BgtReservedBalance) }}</div>
				<div class="text-center">
					<v-chip x-small dark color="primary" class="pa-2 rounded font-weight-bold">
						{{ formatMoneyUSD(row.BgtReservedBalanceUSD) }}
					</v-chip>
				</div>
			</template>

			<template v-slot:BgtExecutedBalance="{ row }">
				<div class="font-weight-medium text-center">{{ formatMoneyPEN(row.BgtExecutedBalance) }}</div>
				<div class="text-center">
					<v-chip x-small dark color="primary" class="pa-2 rounded font-weight-bold">
						{{ formatMoneyUSD(row.BgtExecutedBalanceUSD) }}
					</v-chip>
				</div>
			</template>

			<template v-slot:BgtAvailableBalance="{ row }">
				<div class="font-weight-medium text-center">{{ formatMoneyPEN(row.BgtAvailableBalance) }}</div>
				<div class="text-center">
					<v-chip x-small dark color="primary" class="pa-2 rounded font-weight-bold">
						{{ formatMoneyUSD(row.BgtAvailableBalanceUSD) }}
					</v-chip>
				</div>
			</template>

			<template v-slot:Active="{ row }">
				<v-chip small v-if="row.PrjCodeSAP" :color="row.Active == 'Y' ? 'success' : 'error'" outlined
					class="font-weight-bold pa-2 caption">
					<v-icon left small class="pl-1">
						{{ row.Active == 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}
					</v-icon>
					{{ row.Active == 'Y' ? 'ACTIVO' : 'INACTIVO' }}
				</v-chip>
				<div v-else>
					<span class="red--text font-weight-light caption font-italic">
						NO DISPONIBLE
					</span>
				</div>
			</template>

			<template v-slot:Locked="{ row }">
				<v-btn v-if="row.PrjCodeSAP" small depressed :color="row.Locked == 'Y' ? 'success' : 'error'"
					@click="toggleProjectLock(row)" class="rounded-lg font-weight-bold text-none pa-2">
					<v-icon left small>
						{{ row.Locked == 'Y' ? 'mdi-lock-open-variant' : 'mdi-lock' }}
					</v-icon>
					{{ row.Locked == 'Y' ? 'DESBLOQUEAR' : 'BLOQUEAR' }}
				</v-btn>
				<div v-else>
					<span class="red--text font-weight-light caption font-italic">
						NO DISPONIBLE
					</span>
				</div>
			</template>
		</s-crud>

		<v-dialog v-model="dialogDetail" max-width="1000px">
			<v-card class="rounded-xl overflow-hidden">
				<v-card-title class="headline d-flex align-center justify-space-between px-5 py-3"
					style="background: linear-gradient(135deg, #2563eb, #1d4ed8); border-bottom: 1px solid #1e40af;">
					<div class="d-flex align-center">
						<v-icon color="white" size="24" class="mr-2">mdi-swap-horizontal</v-icon>
						<span class="font-weight-black subtitle-1 white--text">Movimientos de Presupuesto</span>
					</div>
					<v-btn icon color="white" @click="dialogDetail = false" small
						style="background: rgba(255, 255, 255, 0.15);">
						<v-icon small>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-4">
					<TrsBudgetDetail v-if="dialogDetail" :bgt-id="selectedBgtId" :budget="selected"
						@saved="onDetailSaved" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Modal para Alteraciones/Ajustes de Presupuesto (Saldo Contable) -->
		<TrsBudgetAlteration v-if="dialogAlteration" v-model="dialogAlteration" :budget="selected"
			@update-budget="onUpdateBudget" />

		<!-- Modal Formulario de Proyecto SAP -->
		<v-dialog v-model="dialogProject" max-width="560px" persistent scrollable>
			<TrsProjectForm v-if="dialogProject" @saved="onProjectSaved" @close="dialogProject = false" />
		</v-dialog>

		<!-- Modal de Selección de Reporte (Soles / Dólares) -->
		<v-dialog v-model="dialogReport" max-width="420px" transition="dialog-bottom-transition">
			<v-card class="rounded-xl overflow-hidden">
				<v-card-title class="headline d-flex align-center justify-space-between px-5 py-3"
					style="background: linear-gradient(135deg, #10b981, #059669); border-bottom: 1px solid #047857;">
					<div class="d-flex align-center">
						<v-icon color="white" size="24" class="mr-2">mdi-file-document-outline</v-icon>
						<span class="font-weight-black subtitle-1 white--text">Exportar Reporte</span>
					</div>
					<v-btn icon color="white" @click="dialogReport = false" small
						style="background: rgba(255, 255, 255, 0.15);">
						<v-icon small>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-5">
					<p class="caption text-center grey--text text--darken-1 mb-4">
						Seleccione la moneda de presentación para el reporte consolidado de presupuesto.
					</p>

					<v-row dense>
						<v-col cols="6">
							<v-card flat class="currency-report-option-card pa-2 text-center rounded-xl cursor-pointer"
								:class="{ 'active-soles': selectedReportCurrency == 1 }"
								@click="selectedReportCurrency = 1">
								<div class="currency-icon-wrapper soles-icon mb-1">
									<v-icon size="28" :color="selectedReportCurrency == 1 ? 'white' : '#059669'">
										mdi-cash-multiple
									</v-icon>
								</div>
								<div class="font-weight-black subtitle-2 text-slate-800">Soles</div>
								<div class="caption text-muted">Reporte en PEN</div>
							</v-card>
						</v-col>
						<v-col cols="6">
							<v-card flat class="currency-report-option-card pa-2 text-center rounded-xl cursor-pointer"
								:class="{ 'active-dolares': selectedReportCurrency == 2 }"
								@click="selectedReportCurrency = 2">
								<div class="currency-icon-wrapper dolares-icon mb-1">
									<v-icon size="28" :color="selectedReportCurrency == 2 ? 'white' : '#2563eb'">
										mdi-currency-usd
									</v-icon>
								</div>
								<div class="font-weight-black subtitle-2 text-slate-800">Dólares</div>
								<div class="caption text-muted">Reporte en USD</div>
							</v-card>
						</v-col>
					</v-row>

					<v-btn block depressed @click="generarReporte()"
						class="font-weight-black py-4 mt-5 rounded-lg text-none elevation-0 subtitle-2"
						:style="selectedReportCurrency == 'PEN' ? 'background: linear-gradient(135deg, #10b981, #059669) !important; color: white;' : 'background: linear-gradient(135deg, #3b82f6, #1d4ed8) !important; color: white;'">
						<v-icon left>mdi-file-download</v-icon>
						GENERAR REPORTE
					</v-btn>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import _TrsBudgeService from "@/services/Treasury/TrsBudgeService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import TrsBudgetDetail from "./TrsBudgetDetail.vue";
import TrsBudgetAlteration from "./TrsBudgetAlteration.vue";
import TrsProjectForm from "./TrsProjectForm.vue";
import _sGenericService from "@/services/General/GenericService";
import _sOtherSupportService from "@/services/Security/OtherSupportService";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default {
	components: {
		sToolbarPerson,
		TrsBudgetDetail,
		TrsBudgetAlteration,
		TrsProjectForm,
	},
	computed: {
		isSelected() {
			return this.selected != null;
		}
	},
	data() {
		return {
			itemsProjects: [],
			dialogDetail: false,
			selectedBgtId: 0,
			dialogAlteration: false,
			dialogProject: false,
			dialogReport: false,
			selectedReportCurrency: "PEN",
			projectSelectKey: 0,
			selected: null,
			PrjCode: "",
			tipoCambio: null,
			filter: {
				PrjCode: "",
				PrjName: "",
			},
			config: {
				service: _TrsBudgeService,
				model: {
					BgtID: "ID",
					SecStatus: "int",
					BgtInitialBalance: "decimal",
					BgtAccountingBalance: "decimal",
					BgtReservedBalance: "decimal",
					BgtExecutedBalance: "decimal",
					BgtAvailableBalance: "decimal",
					BgtYear: "number",
				},
				headers: [
					{ text: "Detalle", value: "Detail", width: 80, sortable: false },
					// { text: "ID", value: "BgtID" },
					{ text: "BLOQUEO", value: "Locked", align: "center" },
					{ text: "ESTADO", value: "Active", align: "center" },
					{ text: "CODIGO", value: "PrjCode", align: "center", width: 120 },
					{ text: "NOMBRE PROYECTO", value: "PrjName", width: 260 },
					{ text: "DESCRIPCIÓN INVERSIÓN", value: "PrjDescription", width: 260 },
					{ text: "TIPO PROYECTO", value: "BgtTypeName", width: 120, align: "center" },
					{ text: "TIPO INVERSIÓN", value: "BgtInvestmentName", width: 120, align: "center" },
					{ text: "CLASIFICACIÓN", value: "BgtClassificationeName" },
					{ text: "GTE. PRESUPUESTO", value: "BgtManagerName", width: 180, align: "center" },
					{ text: "GTE. RESPONSABLE", value: "PrjResponsibleManagerName", width: 180 },
					{ text: "USUARIO RESPONSABLE", value: "PrjResponsibleUserName", width: 180 },
					{ text: "S. INICIAL", value: "BgtInitialBalance", width: 130, align: "center" },
					{ text: "T/C SAP", value: "BgtRatePrice", width: 80, align: "center" },
					{ text: "S. CONTABLE", value: "BgtAccountingBalance", width: 140, align: "center" },
					{ text: "S. COMPROMETIDO", value: "BgtReservedBalance", width: 140, align: "center" },
					{ text: "S. EJECUTADO", value: "BgtExecutedBalance", width: 140, align: "center" },
					{ text: "S. DISPONIBLE", value: "BgtAvailableBalance", width: 140, align: "center" },
					{ text: "CENTRO COSTO", value: "CceName", width: 150, align: "center" },
					{ text: "LÍNEA DE NEGOCIO", value: "BslName", width: 150, align: "center" },
					{ text: "AÑO", value: "BgtYear", width: 70, align: "center" },
				],
			},
		};
	},

	methods: {
		onClearForm() {
			this.$nextTick(() => {
				if (this.$refs.scrudBudget && this.$refs.scrudBudget.row) {
					this.$set(this.$refs.scrudBudget.row, 'BgtYear', new Date().getFullYear());
					this.$set(this.$refs.scrudBudget.row, 'BgtCurrencyType', 1);
				}
			});
		},

		async onProjectSaved() {
			await this.loadProjects();
			this.dialogProject = false;
			this.projectSelectKey++;
		},

		async toggleProjectLock(row) {
			const action = row.Locked == 'Y' ? 'desbloquear' : 'bloquear';
			const confirm = await this.$fun.alert(`¿Está seguro de ${action} el proyecto "${row.PrjCode}"?`, "question");
			if (!confirm.value) return;
			try {
				const payload = {
					PrjCode: row.PrjCode,
					PrjName: row.PrjName,
					Locked: row.Locked == 'Y' ? 'N' : 'Y',
					Active: row.Active,
					UserSign: this.$fun.getUserID(),
				};
				const response = await _TrsBudgeService.changeProjectLock(payload, this.$fun.getUserID());
				if (response.status === 200) {
					this.$fun.alert(`Proyecto ${action == 'bloquear' ? 'bloqueado' : 'desbloqueado'} exitosamente.`, "success");
					this.$refs.scrudBudget.refresh();
				}
			} catch (error) {
				let message = `Error al intentar ${action} el proyecto.`;
				if (error.response && error.response.data) {
					const d = error.response.data;
					if (typeof d === "string" && d.length > 0) message = d;
					else if (d.message) message = d.message;
					else if (d.Message) message = d.Message;
				}
				this.$fun.alert(message, "error");
			}

		},

		onEditEvent(item) {
			if (!item) {
				this.$fun.alert("No se ha seleccionado registro", "warning");
				return;
			}
			this.selected = item ? { ...item } : null;
		},

		rowSelected(item) {
			// console.log(JSON.parse(JSON.stringify(item)));
			if (item && item.length > 0) {
				const newBgtID = item[0].BgtID;
				if (this.$refs.scrudBudget && this.$refs.scrudBudget.showForm) {
					if (this.selected && this.selected.BgtID !== newBgtID) {
						const toolbar = this.$refs.scrudBudget.$refs.toolbar;
						if (toolbar && typeof toolbar.cancel === "function") {
							toolbar.cancel();
						}
					}
				}
				if (this.$refs.scrudBudget) {
					if (this.$refs.scrudBudget.row) {
						delete this.$refs.scrudBudget.row.SecStatus;
					}
					if (this.$refs.scrudBudget.$refs.toolbar && this.$refs.scrudBudget.$refs.toolbar.entity) {
						delete this.$refs.scrudBudget.$refs.toolbar.entity.SecStatus;
					}
				}
				this.selected = { ...item[0] };
			} else {
				if (!this.dialogAlteration && !this.dialogDetail) {
					this.selected = null;
				}
			}
		},

		generarReporte() {
			this.dialogReport = false;
			this.exportarReporteExcel();
		},

		async exportarReporteExcel() {
			const data = await this.getReportData();

			if (!data || data.length === 0) {
				this.$fun.alert("NO SE ENCONTRARON REGISTROS PARA EXPORTAR.", "warning");
				return;
			}

			const workbook = new ExcelJS.Workbook();
			const sheetName = `Control PI`;
			const worksheet = workbook.addWorksheet(sheetName, {
				properties: { tabColor: { argb: "FF1F4E78" } }
			});

			// 1. DEFINICIÓN DE COLUMNAS (34 columnas con los nombres y orden exactos)
			worksheet.columns = [
				{ header: "Código Proyecto", key: "PrjCode", width: 18 },
				{ header: "Nombre de inversión", key: "PrjName", width: 28 },
				{ header: "Detalle de Inversión", key: "PrjDescription", width: 35 },
				{ header: "Gerente Responsable", key: "GerenteResponsable", width: 22 },
				{ header: "Usuario Responsable", key: "UsuarioResponsable", width: 22 },
				{ header: "Gerencia", key: "Gerencia", width: 20 },
				{ header: "Área", key: "Area", width: 18 },
				{ header: "División", key: "Division", width: 18 },
				{ header: "línea de negocio", key: "LineaNegocio", width: 18 },
				{ header: "Tipo de Proyecto", key: "TipoProyecto", width: 18 },
				{ header: "Tipo de inversión", key: "TipoInversion", width: 18 },
				{ header: "Clasificación", key: "Clasificacion", width: 18 },
				{ header: "Año", key: "Anio", width: 10 },
				{ header: "Carry over", key: "CarryOver", width: 15 },
				{ header: "Presupuesto aprobado", key: "PresupuestoAprobado", width: 22 },
				{ header: " Incremento/Nuevo pedido ", key: "IncrementoNuevoPedido", width: 24 },
				{ header: "Disminución", key: "Disminucion", width: 15 },
				{ header: "Presupuesto Ajustado", key: "PresupuestoAjustado", width: 22 },
				{ header: "Enero", key: "Ene", width: 10 },
				{ header: "Febrero", key: "Feb", width: 10 },
				{ header: "Marzo", key: "Mar", width: 10 },
				{ header: "Abril", key: "Abr", width: 10 },
				{ header: "Mayo", key: "May", width: 10 },
				{ header: "Junio", key: "Jun", width: 10 },
				{ header: "Julio", key: "Jul", width: 10 },
				{ header: "Agosto", key: "Ago", width: 10 },
				{ header: "Setiembre", key: "Set", width: 10 },
				{ header: "Octubre", key: "Oct", width: 10 },
				{ header: "Noviembre", key: "Nov", width: 10 },
				{ header: "Diciembre", key: "Dic", width: 10 },
				{ header: "Total Ejecutado", key: "TotalEjecutado", width: 18 },
				{ header: "Comprometido", key: "Comprometido", width: 18 },
				{ header: "Asignado", key: "Asignado", width: 18 },
				{ header: "Disponible", key: "Disponible", width: 18 },
				{ header: "Ordenes Asociadas", key: "AssociatedOrders", width: 18 }
			];

			// Helper para convertir índice numérico de columna a letra (ej: 1 -> A, 14 -> N)
			const colLetter = (idx) => {
				let temp = idx;
				let letter = "";
				while (temp > 0) {
					let modulo = (temp - 1) % 26;
					letter = String.fromCharCode(65 + modulo) + letter;
					temp = Math.floor((temp - modulo) / 26);
				}
				return letter;
			};

			// 2. DISEÑO Y ESTILO DE CABECERAS
			const headerRow = worksheet.getRow(1);
			headerRow.height = 32;

			for (let colIdx = 1; colIdx <= 35; colIdx++) {
				const cell = headerRow.getCell(colIdx);
				cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
				cell.border = {
					top: { style: 'thin', color: { argb: 'FFD3D3D3' } },
					left: { style: 'thin', color: { argb: 'FFD3D3D3' } },
					bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } },
					right: { style: 'thin', color: { argb: 'FFD3D3D3' } }
				};

				// Color de cabeceras según agrupamiento solicitado
				if (colIdx >= 1 && colIdx <= 13) {
					// Grupo 1: Azul (Proyecto y Metadata básica)
					cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F4E78' } };
					cell.font = { name: 'Calibri', size: 9, bold: true, color: { argb: 'FFFFFFFF' } };
				} else if (colIdx >= 14 && colIdx <= 18) {
					// Grupo 2: Verde (Carry over y saldos ajustados de presupuesto)
					cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF385723' } };
					cell.font = { name: 'Calibri', size: 9, bold: true, color: { argb: 'FFFFFFFF' } };
				} else if (colIdx >= 19 && colIdx <= 30) {
					// Grupo 3: Azul (Meses Enero - Diciembre)
					cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F4E78' } };
					cell.font = { name: 'Calibri', size: 9, bold: true, color: { argb: 'FFFFFFFF' } };
				} else if (colIdx >= 31 && colIdx <= 34) {
					// Grupo 4: Naranja/Marrón (Métricas de Ejecución y Disponibilidad)
					cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC65911' } };
					cell.font = { name: 'Calibri', size: 9, bold: true, color: { argb: 'FFFFFFFF' } };
				} else if (colIdx >= 35 && colIdx <= 35) {
					// Grupo 4: Morado (Métricas de Ordenes Vinculadas)
					cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'A3007D' } };
					cell.font = { name: 'Calibri', size: 9, bold: true, color: { argb: 'FFFFFFFF' } };
				}
			}

			// 3. AGREGAR REGISTROS E INYECTAR FÓRMULAS / ESTILOS
			data.forEach(item => {
				const carryOver = Number(item.CarryOver) || 0;
				const presupuestoAprobado = Number(item.PresupuestoAprobado) || 0;
				const incrementoNuevoPedido = Number(item.IncrementoNuevoPedido) || 0;
				const disminucion = Number(item.Disminucion) || 0;

				const presupuestoAjustado = presupuestoAprobado + carryOver + incrementoNuevoPedido - disminucion;

				const totalEjecutado = [
					item.Ene, item.Feb, item.Mar, item.Abr, item.May, item.Jun,
					item.Jul, item.Ago, item.Set, item.Oct, item.Nov, item.Dic
				].reduce((sum, val) => sum + (Number(val) || 0), 0);

				const comprometido = Number(item.Comprometido) || 0;
				const asignado = totalEjecutado + comprometido;
				const disponible = presupuestoAjustado - asignado;

				const row = worksheet.addRow({
					PrjCode: item.PrjCode,
					PrjName: item.PrjName,
					PrjDescription: item.PrjDescription,
					GerenteResponsable: item.GerenteResponsable,
					UsuarioResponsable: item.UsuarioResponsable,
					Gerencia: item.Gerencia,
					Area: item.Area,
					Division: item.Division,
					LineaNegocio: item.LineaNegocio,
					TipoProyecto: item.TipoProyecto,
					TipoInversion: item.TipoInversion,
					Clasificacion: item.Clasificacion,
					Anio: item.Anio,
					CarryOver: carryOver,
					PresupuestoAprobado: presupuestoAprobado,
					IncrementoNuevoPedido: incrementoNuevoPedido,
					Disminucion: disminucion,
					PresupuestoAjustado: presupuestoAjustado,
					Ene: item.Ene || null,
					Feb: item.Feb || null,
					Mar: item.Mar || null,
					Abr: item.Abr || null,
					May: item.May || null,
					Jun: item.Jun || null,
					Jul: item.Jul || null,
					Ago: item.Ago || null,
					Set: item.Set || null,
					Oct: item.Oct || null,
					Nov: item.Nov || null,
					Dic: item.Dic || null,
					TotalEjecutado: totalEjecutado,
					Comprometido: comprometido,
					Asignado: asignado,
					Disponible: disponible,
					AssociatedOrders: item.AssociatedOrders
				});

				row.height = 24;

				row.eachCell({ includeEmpty: true }, (cell, colIdx) => {
					// Borde delgado para datos
					cell.border = {
						top: { style: 'thin', color: { argb: 'FFE0E0E0' } },
						left: { style: 'thin', color: { argb: 'FFE0E0E0' } },
						bottom: { style: 'thin', color: { argb: 'FFE0E0E0' } },
						right: { style: 'thin', color: { argb: 'FFE0E0E0' } }
					};

					cell.font = { name: 'Calibri', size: 9 };

					// Alineación y formatos específicos
					if (colIdx >= 1 && colIdx <= 12) {
						cell.alignment = { vertical: 'middle', horizontal: 'left' };
					} else if (colIdx === 13) {
						cell.alignment = { vertical: 'middle', horizontal: 'center' };
					} else if (colIdx >= 14 && colIdx <= 34) {
						// Columnas numéricas
						cell.numFmt = '#,##0.00';
						cell.alignment = { vertical: 'middle', horizontal: 'right' };
						const val = Number(cell.value);
						if (val && val !== 0) {
							// Estilo de número de la imagen: Negrita y Color Rojo Oscuro
							cell.font = { name: 'Calibri', size: 9, bold: true, color: { argb: 'FFC00000' } };
						}
					} else if (colIdx === 35) {
						cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
					}
				});
			});

			// 4. FILA DE TOTALES GENERALES
			const totalsRow = worksheet.addRow([]);
			totalsRow.height = 26;

			const firstCell = totalsRow.getCell(1);
			firstCell.value = "TOTAL GENERAL";
			firstCell.font = { name: 'Calibri', size: 9, bold: true };
			firstCell.alignment = { vertical: 'middle', horizontal: 'left' };

			for (let colIdx = 1; colIdx <= 35; colIdx++) {
				const cell = totalsRow.getCell(colIdx);
				cell.border = {
					top: { style: 'thin', color: { argb: 'FFB0B0B0' } },
					left: { style: 'thin', color: { argb: 'FFB0B0B0' } },
					bottom: { style: 'double', color: { argb: 'FF000000' } },
					right: { style: 'thin', color: { argb: 'FFB0B0B0' } }
				};

				const letter = colLetter(colIdx);
				const dataStart = 2;
				const dataEnd = data.length + 1;

				const isNumeric = colIdx >= 14 && colIdx <= 34;

				if (isNumeric) {
					cell.value = { formula: `SUM(${letter}${dataStart}:${letter}${dataEnd})` };
					cell.font = { name: 'Calibri', size: 9, bold: true, color: { argb: 'FFC00000' } };
					cell.numFmt = '#,##0.00';
					cell.alignment = { vertical: 'middle', horizontal: 'right' };
				} else if (colIdx > 1) {
					cell.alignment = { vertical: 'middle', horizontal: 'left' };
				}
			}

			// 5. CONFIGURACIÓN FINAL DE VISTA (Autofilter y congelar filas/columnas)
			worksheet.autoFilter = {
				from: { row: 1, column: 1 },
				to: { row: 1, column: 34 }
			};

			worksheet.views = [
				{
					state: 'frozen',
					// xSplit: 5, // Congela hasta Usuario Responsable inclusive
					ySplit: 1, // Congela la fila de cabecera
					zoomScale: 100,
					showGridLines: true
				}
			];

			const buffer = await workbook.xlsx.writeBuffer();
			saveAs(new Blob([buffer]), `REPORTE_PRESUPUESTO_DETALLE_${this.selectedReportCurrency == 1 ? 'SOLES' : 'USD'}.xlsx`);
		},

		onProjectSelected(prjCode, item) {
			if (prjCode) {
				this.$set(item, "PrjCode", prjCode);
				const project = this.itemsProjects.find(p => p.GenHelper === prjCode);
				this.$set(item, "PrjName", project ? project.GenDescription : null);
			} else {
				this.$set(item, "PrjCode", null);
				this.$set(item, "PrjName", null);
			}
		},
		async onProjectSearch(event, item) {
			let records = [];
			const PrjCode = item.PrjCode;
			if (!PrjCode || PrjCode.length < 1) return;
			const params = { requestID: this.$fun.getUserID() };

			try {
				const result = await this.$http.post(_sGenericService.getUrlProjects(), { PrjCode }, { params });
				if (result.status == 200) {
					records = result.data;
				}
				this.$set(item, "PrjCode", records.length > 0 ? records[0].GenHelper : null);
				this.$set(item, "PrjName", records.length > 0 ? records[0].GenDescription : null);
				if (records.length == 0) {
					this.$fun.alert("NO SE HA ENCONTRADO PROYECTO CON EL CODIGO " + PrjCode, "warning");
					return;
				}
			} catch (error) {
				console.error(error);
			}
		},
		async loadProjects() {
			const params = { requestID: this.$fun.getUserID() };
			try {
				const result = await this.$http.post(_sGenericService.getUrlProjects(), { LoadAll: 1 }, { params });
				this.itemsProjects = result.status == 200 ? result.data : [];
				// console.log(JSON.parse(JSON.stringify(this.itemsProjects)));
			} catch (error) {
				this.itemsProjects = [];
				console.error(error);
			}
		},
		onCenterCostSelected(val, item) {
			// item.BslID = val ? val.GenID : null;
			// if (val) {
			// 	this.$set(item, "BslID", val.GenID);
			// } else {
			// 	this.$set(item, "BslID", null);
			// }
			// console.log((JSON.parse(JSON.stringify({ val }))));
			// console.log((JSON.parse(JSON.stringify({ item }))));
		},
		onPersonSelected(person, item, fieldPrefix) {
			if (person) {
				// console.log(JSON.parse(JSON.stringify(person)));
				this.$set(item, fieldPrefix, person.PrsID);
				this.$set(item, fieldPrefix + "Name", person.NtpFullName);
				this.$set(item, fieldPrefix + "Document", person.PrsDocumentNumber);

				if (fieldPrefix == 'PrjResponsibleManager') {
					this.$set(item, 'AreID', person.AreID);
				}
			} else {
				this.$set(item, fieldPrefix, null);
				this.$set(item, fieldPrefix + "Name", null);
				this.$set(item, fieldPrefix + "Document", null);
			}
		},
		openDetail(id) {
			this.selectedBgtId = id;
			this.dialogDetail = true;
		},
		onDetailSaved() {
			this.$refs.scrudBudget.refresh();
			this.refreshSelectedBudget();
		},
		async saveBudget(item) {

			if (!item.BgtCurrencyType) {
				// item.BgtCurrencyType = 1;
				this.$fun.alert("Debe seleccionar el tipo de moneda base del presupuesto", "warning");
				return;
			}

			// Autocompletar tipo de cambio si no fue ingresado manualmente
			if (!item.BgtRatePrice && this.tipoCambio) {
				item.BgtRatePrice = this.tipoCambio;
			}

			console.log(JSON.parse(JSON.stringify(item)));

			// Autocompletar tipo de cambio si no fue ingresado manualmente
			if (!item.BgtRatePrice && this.tipoCambio) {
				item.BgtRatePrice = this.tipoCambio;
			}

			if (!item.PrjCode || item.PrjCode == "") {
				this.$fun.alert("Debe agregar un proyecto", "warning");
				return;
			}

			// Validar si el proyecto existe
			const PrjCode = item.PrjCode;
			const params = { requestID: this.$fun.getUserID() };
			try {
				const result = await this.$http.post(_sGenericService.getUrlProjects(), { PrjCode, LoadAll: 1 }, { params });
				let isValid = false;
				if (result.status == 200 && result.data && result.data.length > 0) {
					const match = result.data.find(r => r.GenHelper && r.GenHelper.toUpperCase() === PrjCode.toUpperCase());
					if (match) {
						isValid = true;
						this.$set(item, "PrjCode", match.GenHelper);
						this.$set(item, "PrjName", match.GenDescription);
					}
				}
				if (!isValid) {
					this.$fun.alert("NO SE HA ENCONTRADO PROYECTO CON EL CODIGO " + PrjCode, "warning");
					return;
				}
			} catch (error) {
				console.error(error);
				this.$fun.alert("Ocurrió un error al validar el proyecto.", "error");
				return;
			}

			// PrjResponsibleManagerDocument
			if (!item.PrjResponsibleManager || item.PrjResponsibleManager == null || item.PrjResponsibleManager == "") {
				this.$fun.alert("Debe ingresar gerente responsable del proyecto", "warning");
				return;
			}

			if (!item.BgtRatePrice || item.BgtRatePrice == null || item.BgtRatePrice == 0) {
				this.$fun.alert("Debe ingresar el tipo de cambio", "warning");
				return;
			}

			if (item.BgtInitialBalance == null || item.BgtInitialBalance == "" || item.BgtInitialBalance <= 0) {
				this.$fun.alert("Debe ingresar saldo inicial en SOLES", "warning");
				return;
			}

			if (!item.BgtInitialBalanceUSD || item.BgtInitialBalanceUSD == null || item.BgtInitialBalanceUSD == 0) {
				this.$fun.alert("Debe ingresar el saldo inicial en DÓLARES", "warning");
				return;
			}

			if (!item.PrjResponsibleUserDocument || item.PrjResponsibleUserDocument == null || item.PrjResponsibleUserDocument == "") {
				this.$fun.alert("Debe ingresar usuario responsable del proyecto", "warning");
				return;
			}

			if (!item.BgtManager || item.BgtManager == null || item.BgtManager == "") {
				this.$fun.alert("Debe ingresar gerente de presupuesto del área", "warning");
				return;
			}

			if (item.AreID == null || item.AreID == "" || item.AreID == 0) {
				this.$fun.alert("Debe seleccionar area", "warning");
				return;
			}
			if (!item.BgtDivision || item.BgtDivision == null || item.BgtDivision == 0) {
				this.$fun.alert("Debe seleccionar una división", "warning");
				return;
			}
			if (!item.BgtType || item.BgtType == null || item.BgtType == 0) {
				this.$fun.alert("Debe seleccionar un tipo de proyecto", "warning");
				return;
			}
			if (item.BgtInvestment == 0) {
				this.$fun.alert("Debe seleccionar un tipo de inversión", "warning");
				return;
			}
			if (item.BgtClassification == 0) {
				this.$fun.alert("Debe seleccionar una clasificación", "warning");
				return;
			}
			if (item.BgtYear == 0) {
				this.$fun.alert("Debe ingresar el año del presupuesto", "warning");
				return;
			}
			if (!item.CceID || item.CceID == null || item.CceID == 0) {
				this.$fun.alert("Debe ingresar el centro de costo", "warning");
				return;
			}
			if (!item.BslID || item.BslID == null || item.BslID == 0) {
				this.$fun.alert("Debe seleccionar la línea del negocio", "warning");
				return;
			}

			item.SecStatus = 1;
			item.UsrCreateID = this.$fun.getUserID();

			// if (item.BgtAccountingBalance == 0) {
			//     this.$fun.alert("Debe ingresar un saldo contable", "warning");
			//     return;
			// }

			const response = await item.save();
			if (response && response.status === 200) {
				if (this.$refs.scrudBudget && this.$refs.scrudBudget.$refs.toolbar) {
					this.$refs.scrudBudget.$refs.toolbar.cancel();
				}
			}
		},

		async getReportData() {
			try {
				const params = { BgtCurrencyType: this.selectedReportCurrency };
				const result = await _TrsBudgeService.report(params, this.$fun.getUserID());
				return result.status == 200 ? result.data : [];
			} catch (error) {
				console.error(error);
			}
		},

		openAlteration(row) {
			this.selected = row;
			this.dialogAlteration = true;
		},
		onUpdateBudget(alteration) {
			this.$refs.scrudBudget.refresh();
			this.refreshSelectedBudget();
		},
		async refreshSelectedBudget() {
			if (this.selected && this.selected.BgtID) {
				const bgtId = this.selected.BgtID;
				try {
					const response = await _TrsBudgeService.list({ BgtID: bgtId }, this.$fun.getUserID());
					if (response.status == 200 && response.data && response.data.length > 0) {
						const updatedBudget = response.data.find(b => b.BgtID === bgtId);
						if (updatedBudget) {
							this.selected = { ...updatedBudget };
						}
					}
				} catch (e) {
					console.error("Error al refrescar el presupuesto seleccionado:", e);
				}
			}
		},
		formatMoney(value) {
			if (value == null || isNaN(value)) return "S/. 0.00";
			return "S/. " + Number(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
		},
		formatMoneyPEN(value) {
			if (value == null || isNaN(value)) return "S/. 0.00";
			return "S/. " + Number(value).toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,');
		},
		formatMoneyUSD(value) {
			if (value == null || isNaN(value)) return "$ 0.00";
			return "$ " + Number(value).toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,');
		},
		async getExchangeRate(date, currencyType) {
			try {
				const result = await _sOtherSupportService.exchangeratesap(date, currencyType, this.$fun.getUserID());
				if (result.status == 200) {
					return result.data.Rate;
				}
				return null;
			} catch (error) {
				console.log("Error al obtener la tasa de cambio:", error);
				return null;
			}
		},
		onRatePriceInput(value, item) {
			const rate = parseFloat(value);
			this.$set(item, 'BgtRatePrice', value);
			if (rate > 0) {
				if (item.BgtCurrencyType == 2) {
					const usd = parseFloat(item.BgtInitialBalanceUSD);
					if (!isNaN(usd) && usd > 0) {
						this.$set(item, 'BgtInitialBalance', parseFloat((usd * rate).toFixed(3)));
					}
				} else {
					const soles = parseFloat(item.BgtInitialBalance);
					if (!isNaN(soles) && soles > 0) {
						this.$set(item, 'BgtInitialBalanceUSD', parseFloat((soles / rate).toFixed(3)));
					}
				}
			}
		},
		onInitialBalanceSolesInput(value, item) {
			const soles = parseFloat(value);
			this.$set(item, 'BgtInitialBalance', value);
			const rate = parseFloat(item.BgtRatePrice) || this.tipoCambio;
			if (!isNaN(soles) && !isNaN(rate) && rate > 0) {
				this.$set(item, 'BgtInitialBalanceUSD', parseFloat((soles / rate).toFixed(3)));
			}
		},
		onInitialBalanceUSDInput(value, item) {
			const usd = parseFloat(value);
			this.$set(item, 'BgtInitialBalanceUSD', value);
			const rate = parseFloat(item.BgtRatePrice) || this.tipoCambio;
			if (!isNaN(usd) && !isNaN(rate) && rate > 0) {
				this.$set(item, 'BgtInitialBalance', parseFloat((usd * rate).toFixed(3)));
			}
		},
	},
	async created() {
		await this.loadProjects();
		const tipoCambio = await this.getExchangeRate(new Date(), "US$");
		console.log("tipoCambio", tipoCambio);
		this.tipoCambio = tipoCambio;
	},
};
</script>

<style scoped>
.premium-budget-workspace {
	min-height: 100%;
}

/* ─── TARJETAS PREMIUM DE TRABAJO ─── */
.workspace-card {
	position: relative;
	background: #ffffff;
	border: 1px solid #e2e8f0;
	border-radius: 16px;
	box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.04), 0 2px 4px -1px rgba(15, 23, 42, 0.02);
	overflow: hidden;
}

/* Borde superior de gradiente */
.card-gradient-top {
	height: 4px;
	width: 100%;
}

.blue-gradient {
	background: linear-gradient(90deg, #3b82f6, #60a5fa);
}

.green-gradient {
	background: linear-gradient(90deg, #10b981, #34d399);
}

.purple-gradient {
	background: linear-gradient(90deg, #8b5cf6, #a78bfa);
}

.pink-gradient {
	background: linear-gradient(90deg, #ec4899, #f472b6);
}

/* ─── CABECERAS INTERNAS ─── */
.card-inner-header {
	display: flex;
	align-items: center;
	padding: 6px 8px 6px 8px;
	border-bottom: 1px solid #f1f5f9;
}

.card-inner-header .v-icon {
	background: #f8fafc;
	padding: 6px;
	border-radius: 10px;
	border: 1px solid #f1f5f9;
	font-size: 18px !important;
}

.title-group {
	display: flex;
	flex-direction: column;
	margin-left: 10px;
}

.title-group h3 {
	font-size: 14px;
	font-weight: 700;
	color: #0f172a;
	margin: 0;
	line-height: 1.2;
}

.title-group p {
	font-size: 10px;
	color: #64748b;
	margin: 2px 0 0 0;
}

/* ─── CUERPO INTERNO ─── */
.card-inner-body {
	padding: 6px 8px 8px 8px;
}

/* ─── PUENTE VISUAL DE MONEDAS (CURRENCY BRIDGE) ─── */
.currency-bridge-layout-2col {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 6px;
	align-items: center;
}

.currency-panel {
	background: rgba(248, 250, 252, 0.7);
	border: 1px solid #e2e8f0;
	border-radius: 14px;
	padding: 8px;
}

.currency-panel:focus-within {
	background: #ffffff;
	border-color: #3b82f6;
	box-shadow: 0 4px 12px rgba(37, 99, 235, 0.05);
}

.panel-header {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 10px;
}

.flag-badge {
	background: #334155;
	color: #ffffff;
	font-weight: 800;
	font-size: 10px;
	padding: 3px 8px;
	border-radius: 6px;
	letter-spacing: 0.05em;
}

.pen-panel .flag-badge {
	background: linear-gradient(135deg, #028237 0%, #024c1d 100%);
}

.usd-panel .flag-badge {
	background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

.currency-name {
	font-size: 12px;
	font-weight: 700;
	color: #334155;
}

/* Indicador TC en Encabezado */
.header-tc-badge {
	background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
	border: 1px solid #fde68a;
	border-radius: 8px;
	padding: 4px 6px;
	display: flex;
	align-items: center;
	gap: 6px;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.header-tc-badge .badge-label {
	font-size: 8px;
	font-weight: 800;
	color: #b45309;
	letter-spacing: 0.05em;
}

.header-tc-badge .badge-value {
	font-size: 10px;
	font-weight: 800;
	color: #78350f;
	font-family: Consolas, Monaco, monospace;
}

/* ─── SIDEBAR GRUPOS ─── */
.sidebar-input-group {
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 12px;
	padding: 4px 6px;
}

.sidebar-input-group:focus-within {
	background: #ffffff;
	border-color: #7c3aed;
}

.name-display {
	display: flex;
	align-items: center;
	background: #f1f5f9;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	padding: 6px 12px;
	font-size: 11px;
	font-weight: 600;
	color: #334155;
}

.name-display-inline {
	display: inline-flex;
	align-items: center;
	background: #f1f5f9;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	padding: 4px 8px;
	font-size: 10px;
	font-weight: 600;
	color: #475569;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* ─── INYECCIÓN Y ANULACIÓN DE ESTILOS DE VUETIFY ─── */
::v-deep .v-text-field--outlined fieldset {
	border-color: #cbd5e1 !important;
	border-radius: 10px !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
	border-color: #2563eb !important;
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15) !important;
}

::v-deep .v-input--is-disabled fieldset {
	background-color: #f1f5f9;
	border-style: dashed !important;
}

/* ─── RESPONSIVIDAD GENERAL ─── */
@media (max-width: 960px) {
	.premium-budget-workspace {
		padding: 12px;
	}

	.currency-bridge-layout-2col {
		grid-template-columns: 1fr;
		gap: 6px;
	}
}

/* ─── MODAL SELECCIONAR REPORTE ─── */
.currency-report-option-card {
	border: 2px solid #e2e8f0 !important;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	cursor: pointer;
	background: #f8fafc !important;
}

.currency-report-option-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
	border-color: #cbd5e1 !important;
}

.currency-icon-wrapper {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	width: 46px;
	height: 46px;
	border-radius: 50%;
	transition: all 0.3s ease;
}

.soles-icon {
	background-color: #ecfdf5;
}

.dolares-icon {
	background-color: #eff6ff;
}

/* Active State Soles */
.currency-report-option-card.active-soles {
	border-color: #10b981 !important;
	background-color: #ffffff !important;
	box-shadow: 0 10px 20px rgba(16, 185, 129, 0.1);
}

.currency-report-option-card.active-soles .soles-icon {
	background: linear-gradient(135deg, #10b981, #059669) !important;
}

/* Active State Dólares */
.currency-report-option-card.active-dolares {
	border-color: #3b82f6 !important;
	background-color: #ffffff !important;
	box-shadow: 0 10px 20px rgba(59, 130, 246, 0.1);
}

.currency-report-option-card.active-dolares .dolares-icon {
	background: linear-gradient(135deg, #3b82f6, #1d4ed8) !important;
}

.text-slate-800 {
	color: #1e293b;
}

.text-muted {
	color: #64748b;
}

/* iOS Segmented Control Switch */
.ios-segmented-control {
	position: relative;
	display: flex;
	background-color: #f1f5f9;
	border-radius: 12px;
	padding: 4px;
	user-select: none;
	border: 1px solid #e2e8f0;
}

.ios-slider {
	position: absolute;
	top: 4px;
	left: 4px;
	width: calc(50% - 4px);
	height: calc(100% - 8px);
	background-color: #ffffff;
	border-radius: 9px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
	transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}

.ios-slider.slide-right {
	transform: translateX(100%);
}

.ios-option {
	position: relative;
	z-index: 1;
	flex: 1;
	text-align: center;
	padding: 8px 0;
	font-size: 11px;
	font-weight: 800;
	color: #94a3b8;
	cursor: pointer;
	transition: color 0.25s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
	letter-spacing: 0.5px;
}

.ios-option.active.option-currency {
	color: #1e293b;
}

/* Conversión automática */
.conversion-preview {
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 6px 12px;
	border-radius: 8px;
	font-size: 11px;
	margin-top: 8px;
}

.pen-panel .conversion-preview {
	background: linear-gradient(135deg, #eff6ff, #dbeafe);
	border: 1px solid #93c5fd;
}

.pen-panel .conversion-value {
	color: #1d4ed8;
}

.usd-panel .conversion-preview {
	background: linear-gradient(135deg, #ecfdf5, #d1fae5);
	border: 1px solid #6ee7b7;
}

.usd-panel .conversion-value {
	color: #047857;
}

.conversion-value {
	font-family: Consolas, Monaco, monospace;
	margin-left: 2px;
}
</style>
